import React, { useState, useEffect, useMemo } from 'react'
import Select from 'react-select';
import Tab from './Tab';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

import ResponceJSON_ONE from './ResponceJSON_ONE';
import RequestJSON_ONE from './RequestJSON_ONE';

import ResponceJSON_TWO from './ResponceJSON_TWO';
import RequestJSON_TWO from './RequestJSON_TWO';

function SettlementMISAPIDropDown() {
    const [OptionData, SetOptionData] = useState([])
    const [selectedOption, SetselectedOption] = useState([])
    useEffect(() => {
        const options = [
            { value: '1', label: 'application/json' },
            { value: '2', label: 'request' }
        ];
        SetOptionData(options)
        SetselectedOption({ value: '1', label: 'application/json' })
    }, []);

    const onChangeSelected = (data) => {
        SetselectedOption(data)
    }

    const MemoFun = useMemo(() => {
        if (selectedOption['value'] == 1) {
            return (
                <>
                    <RequestJSON_ONE selectedOptionData={selectedOption} />
                    <ResponceJSON_ONE />
                </>)
        } else {
            return (<>
                <RequestJSON_TWO selectedOptionData={selectedOption} />
                <ResponceJSON_TWO />
            </>)
        }
    }, [selectedOption])


    const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
    const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
    const onClickAccordianShowHideOne = () => {
        SetShowHideAccordionOne(!ShowHideAccordionOne)
    }
    const onClickAccordianShowHideTwo = () => {
        SetShowHideAccordionTwo(!ShowHideAccordionTwo)
    }
    const [TabCheck, SetTabCheck] = useState(false)
    const [TabCheck1, SetTabCheck1] = useState(false)
    const [TabCheck2, SetTabCheck2] = useState(false)
    const onClickCangeTab = () => {
        SetTabCheck(!TabCheck);
    }
    const onClickCangeTab1 = () => {
        SetTabCheck1(!TabCheck1);
    }
    const onClickCangeTab2 = () => {
        SetTabCheck2(!TabCheck2);
    }

    return (
        <>
            <div class="row">
                <div class="col-md-8 mt-60">
                    <h2 id="get-settlement-mis-details-sec">Get Settlement MIS Detail API</h2>
                    <h5>Header Parameters:</h5>
                    <table class="table table-bordered mt-20">
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Mandatory</th>
                                <th>Remarks</th>
                                <th>Value</th>
                            </tr>
                            <tr>
                                <td>Content-Type</td>
                                <td>String</td>
                                <td>Yes</td>
                                <td>
                                </td>
                                <td>application/json</td>
                            </tr>
                            <tr>
                                <td>userId</td>
                                <td>String</td>
                                <td>Yes</td>
                                <td>This contains userId</td>
                                <td>Adidas</td>
                            </tr>
                            <tr>
                                <td>sessionKey</td>
                                <td>String</td>
                                <td>Yes</td>
                                <td>This contains will get in response after login</td>
                                <td>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h5>Request Parameters:</h5>
                    <table class="table table-bordered mt-20">
                        <tbody>
                            <tr>
                                <th>Parameter</th>
                                <th>Is Mandatory</th>
                                <th>Test Value</th>
                                <th>Description</th>
                            </tr>
                            <tr>
                                <td>from_date</td>
                                <td>Yes</td>
                                <td>2018-04-03</td>
                                <td>beginning from date yyyy-mm-dd</td>
                            </tr>
                            <tr>
                                <td>to_date</td>
                                <td>Yes</td>
                                <td>2020-04-03</td>
                                <td>till date yyyy-mm-dd</td>
                            </tr>
                        </tbody>
                    </table>
                    <h6><u>AUTHORIZATIONS:</u></h6>
                    <h6 className="mt-10">HEADER PARAMETERS</h6>
                    <hr class="hr-col">
                    </hr>
                    <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                            <tr>
                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Content-Type">
                                    <span class="sc-iemWCZ fhDkLh"></span><span>Content-Type</span>
                                    <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                        <div>
                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>application/json</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="userId">
                                    <span class="sc-iemWCZ fhDkLh"></span><span>userId</span>
                                    <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                        <div>
                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>This contains encrypted userId with AES encryption</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="last undefined">
                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sessionKey">
                                    <span class="sc-iemWCZ fhDkLh"></span><span>sessionKey</span>
                                    <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                        <div>
                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>This contains will get in response after login.</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {/* <h6>REQUEST BODY SCHEMA:  application-json</h6> */}
                    <div class="select-wrap">
                        <div style={{ display: "flex" }}>
                            <h2>REQUEST BODY SCHEMA: </h2>
                            <Select
                                value={selectedOption}
                                onChange={onChangeSelected}
                                options={OptionData}
                            />
                        </div>
                        <div>
                            {selectedOption['value'] == 1 ?
                                <>
                                    <table class="sc-hHEiqL iZJLLY">
                                        <tbody>
                                            <tr>
                                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fromDate"><span class="sc-iemWCZ fhDkLh"></span><span>fromDate</span></td>
                                                <td class="sc-bkbkJK gmOLLi">
                                                    <div>
                                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                        <div>
                                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                                <p>Transactions beginning from date.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="last undefined">
                                                <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="toDate"><span class="sc-iemWCZ fhDkLh"></span><span>toDate</span></td>
                                                <td class="sc-bkbkJK gmOLLi">
                                                    <div>
                                                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                        <div>
                                                            <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                                <p>Transactions till date</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </>
                                :
                                <>
                                    <h1>Schema not provided</h1>
                                </>}
                        </div>
                    </div>
                    <hr class="hr-col">
                    </hr>

                    <h5 className="mt-30">Responses</h5>
                    <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
                        <div class="card">
                            <div class="card-header" id="heading1">
                                <h5 class="mb-0">
                                    <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                                        <b>200</b> A refund reponse json object {TabCheck1 ?
                                            <FaAngleUp />
                                            :
                                            <FaAngleDown />
                                        }
                                    </div>
                                </h5>
                            </div>
                            {
                                TabCheck1 &&
                                <div>
                                    <div class="card-body">
                                        <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                                        <hr class="hr-col">
                                        </hr>
                                        <table class="sc-hHEiqL iZJLLY">
                                            <tbody>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="settlement_ID"><span class="sc-iemWCZ fhDkLh"></span><span>settlement_ID</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="aG_ID"><span class="sc-iemWCZ fhDkLh"></span><span>aG_ID</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_ID"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_ID</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_Name"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_Name</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="aG_Ref"><span class="sc-iemWCZ fhDkLh"></span><span>aG_Ref</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_Number"><span class="sc-iemWCZ fhDkLh"></span><span>order_Number</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_Type"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_Type</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fee"><span class="sc-iemWCZ fhDkLh"></span><span>fee</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mE_IGST"><span class="sc-iemWCZ fhDkLh"></span><span>mE_IGST</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mE_CGST"><span class="sc-iemWCZ fhDkLh"></span><span>mE_CGST</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mE_SGST"><span class="sc-iemWCZ fhDkLh"></span><span>mE_SGST</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="net_Amount"><span class="sc-iemWCZ fhDkLh"></span><span>net_Amount</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="settlement_Date"><span class="sc-iemWCZ fhDkLh"></span><span>settlement_Date</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_Date"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_Date</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pG_ID"><span class="sc-iemWCZ fhDkLh"></span><span>pG_ID</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pG_Name"><span class="sc-iemWCZ fhDkLh"></span><span>pG_Name</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uDF1"><span class="sc-iemWCZ fhDkLh"></span><span>uDF1</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uDF2"><span class="sc-iemWCZ fhDkLh"></span><span>uDF2</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uDF3"><span class="sc-iemWCZ fhDkLh"></span><span>uDF3</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uDF4"><span class="sc-iemWCZ fhDkLh"></span><span>uDF4</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="last undefined">
                                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uDF5"><span class="sc-iemWCZ fhDkLh"></span><span>uDF5</span></td>
                                                    <td class="sc-bkbkJK gmOLLi">
                                                        <div>
                                                            <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                            <div>
                                                                <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0"> <span>400 Bad request</span> </h5>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="mb-0"> <span>404 Not found</span> </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 extreme-rt-div">
                    <Tab />
                    {MemoFun}
                </div>
            </div>
        </>
    )
}

export default SettlementMISAPIDropDown